// categories-slider.js
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {

    // Znajdź wszystkie kontenery sliderów kategorii na stronie
    const categorySliderContainers = document.querySelectorAll('[data-category-slider-container]');

    // Jeśli nie ma żadnego kontenera, zakończ
    if (categorySliderContainers.length === 0) return;

    // Dla każdego kontenera inicjalizuj Swiper z zewnętrznymi przyciskami
    categorySliderContainers.forEach((container) => {
        // Pobierz unikalny identyfikator kontenera
        const containerId = container.getAttribute('data-category-slider-container');

        // Znajdź elementy wewnątrz tego kontenera
        const slider = container.querySelector('[data-category-slider-id="' + containerId + '"]');
        const pagination = container.querySelector('[data-category-slider-pagination="' + containerId + '"]');
        const prevButton = container.querySelector('[data-category-slider-prev="' + containerId + '"]');
        const nextButton = container.querySelector('[data-category-slider-next="' + containerId + '"]');

        // Sprawdź, czy slider istnieje
        if (!slider) {
            console.warn(`Category slider element with data-category-slider-id="${containerId}" not found`);
            return;
        }


        // Inicjalizacja Swipera dla tego kontenera
        const swiperInstance = new Swiper(slider, {
            // Załaduj moduły
            modules: [Pagination, Navigation, Autoplay],

            // Podstawowe ustawienia
            slidesPerView: 2.3,  // Domyślnie pokazuje 1 slajd
            spaceBetween: 15,  // Odstęp między slajdami


            // Autoplay (opcjonalnie)
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },

            // Opcje paginacji (jeśli element istnieje)
            pagination: pagination ? {
                el: pagination,
                clickable: true,
            } : false,

            // Przyciski nawigacji (jeśli elementy istnieją)
            navigation: (nextButton && prevButton) ? {
                nextEl: nextButton,
                prevEl: prevButton,
            } : false,

            // Ustawienia responsywne zgodnie z wymaganiami
            breakpoints: {
                // >= 768px
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                // >= 968px
                968: {
                    slidesPerView: 2.8,
                    spaceBetween: 30,
                },
                // >= 1024px
                1024: {
                    slidesPerView: 3.5,
                    spaceBetween: 30,
                },
                // >= 1200px
                1200: {
                    slidesPerView: 4.5,
                    spaceBetween: 30,
                },
                // >= 1300px
                1300: {
                    slidesPerView: 5.5,
                    spaceBetween: 30,
                },
            }
        });
    });
});